import { setInfluenceAnalysisAttributes as setInfluenceAnalysisAttributesDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    attributes?: [],
    reProcess?: boolean
}

export const setInfluenceAnalysisAttributes = ({
    attributes,
    reProcess,
    eventEmitter,
}: Props) => {
    setInfluenceAnalysisAttributesDiagram(attributes)
    if (reProcess === true) apiProvider.updateDiagramInfluencers();
};

